import { LitElement, html, css } from '@hh/global.js'

class HHRadioWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  render() {
    return html`
      <div>
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
      </div>
    `
  }

  static styles = css`
    div {
      align-items: center;
      display: flex;
      gap: 6px;
    }

    div:hover ::slotted(input) {
      border-color: var(--hh-color-aged-black);
      cursor: pointer;
    }

    ::slotted(input) {
      appearance: none;
      border: 1px solid var(--hh-color-ancient-ore, #000);
      border-radius: 50%;
      height: 16px;
      margin: 0;
      position: relative;
      width: 16px;
    }

    ::slotted(label) {
      color: var(--hh-color-aged-black);
      cursor: pointer;
      font: var(--hh-body-font);
      position: relative;
    }

    :host([checked='true']) ::slotted(input):after {
      content: '';
      background-color: var(--hh-color-fermented-honey, #ad7821);
      border-radius: 50%;
      display: block;
      height: 10px;
      inset: 2px;
      position: absolute;
      width: 10px;
    }
  `
}

customElements.define('hh-radio-wrapper', HHRadioWrapper)
